module.exports = __webpack_public_path__ + "1792395595471/fonts/Flaticon.3d1170b.woff";